import { addTouchDeviceClass } from './helpers/utilify';
import Swiper, { Lazy, Autoplay, A11y, Pagination, Navigation } from 'swiper';
import ScrollOut from 'scroll-out';
// import ExcerptsSwiper from './modules/excerpts-swiper';
import GNav from './modules/app-global-navigation';
import appHeader from './modules/app-header';
import ClickToScrollIntoView from './modules/click-to-scroll-into-view';
import toggleClassOnScroll from './modules/toggle-class-on-scroll';

import '@/vue/app.js';

// https://swiperjs.com/
Swiper.use([Lazy, Autoplay, A11y, Pagination, Navigation]);

addTouchDeviceClass();

document.addEventListener(
  'DOMContentLoaded',
  () => {
    ScrollOut({
      once: true,
      threshold: 0.3,
    });

    /**
     * グローバルナビゲーション
     */
    GNav.init({
      gnavSelector: '#gnav',
      triggerSelector: '#gnav-trigger',
      largeMediaQuery: '(min-width: 992px)',
      currentBar: '#gnav-current-bar',
    });

    /**
     * ヘッダ
     */
    const header = document.querySelector('#header');
    const gnav = document.querySelector('#gnav');
    appHeader(header, gnav);

    /**
     * アンカーリンク
     */
    const headerHeight = 72; // 厳密でない。MAX値
    // eslint-disable-next-line no-new
    new ClickToScrollIntoView('.js-anchor-link', {
      offsetY: headerHeight,
    });

    /**
     * For Easy Table of Contents Plugin
     * @see https://ja.wordpress.org/plugins/easy-table-of-contents/
     */
    // eslint-disable-next-line no-new
    new ClickToScrollIntoView('.ez-toc-link', {
      offsetY: headerHeight,
    });

    /**
     * 画面の紹介
     */
    // eslint-disable-next-line no-new
    new Swiper('#pickup-swiper', {
      slidesPerView: 1,
      // slidesPerGroup: 1,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    /**
     * TOP：無料で試してみる
     */
    const entryTrialElm = document.querySelector('#entry-trial');
    toggleClassOnScroll(entryTrialElm, {
      onScroll: (scrollY) => {
        const lastY = document.body.clientHeight - window.innerHeight;
        if (scrollY >= lastY) {
          entryTrialElm.classList.remove('is-visible');
        }
      },
    });

    /**
     * スクロールトップ
     */
    toggleClassOnScroll(document.querySelector('#scroll-top'));
  },
  false
);

window.addEventListener(
  'load',
  () => document.body.classList.add('is-loaded'),
  false
);
